import { UnitMaster } from '../../../Units/reducer'

export const buildUnitOptions = ({
  individualUnits,
  selectedRow,
}: {
  individualUnits: UnitMaster[]
  selectedRow: UnitMaster
}) => {
  return individualUnits
    .filter(
      (x) =>
        x.size === selectedRow.size &&
        x.isClimate === selectedRow.isClimate &&
        x.isCovered === selectedRow.isCovered
    )
    .filter((x) => !x.customerProfileId || x.id === selectedRow.id)
}
